<template>
    <v-dialog v-model="shows" fullscreen persistent>
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-sheet>
            <v-sheet id="print-target" width="1080" max-width="100%" class="mx-auto pa-60 pa-lg-120">
                <resume-personal-information :value="value.resume" mode="view" />
                <resume-name :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-education :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-work-experience :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-hash-tags :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-languages :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-office-skills :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-certifications :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <resume-cover-letter :value="value.resume" mode="view" class="mt-30 mt-lg-60" />
                <template v-if="!!value.questions.length">
                    <v-sheet class="mt-30 mt-lg-60">
                        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">
                            추가질문답변
                        </h5>

                        <v-divider class="primary border-2" />
                        <question-item v-for="(item, index) in value.questions" :key="item.question._id" v-bind="{ value: item, index }" readonly class="mt-10 mt-lg-20" />
                    </v-sheet>
                </template>
            </v-sheet>
        </v-sheet>
    </v-dialog>
</template>

<script>
import { initApplication } from "@/assets/variables";

import ResumePersonalInformation from "@/components/client/resume/resume-personal-information.vue";
import ResumeName from "@/components/client/resume/resume-name.vue";
import ResumeEducation from "@/components/client/resume/resume-education.vue";
import ResumeWorkExperience from "@/components/client/resume/resume-work-experience.vue";
import ResumeHashTags from "@/components/client/resume/resume-hash-tags.vue";
import ResumeLanguages from "@/components/client/resume/resume-languages.vue";
import ResumeOfficeSkills from "@/components/client/resume/resume-office-skills.vue";
import ResumeCertifications from "@/components/client/resume/resume-certifications.vue";
import ResumeCoverLetter from "@/components/client/resume/resume-cover-letter.vue";
import QuestionItem from "@/components/client/application/questions/question-item.vue";

export default {
    components: {
        ResumePersonalInformation,
        ResumeName,
        ResumeEducation,
        ResumeWorkExperience,
        ResumeHashTags,
        ResumeLanguages,
        ResumeOfficeSkills,
        ResumeCertifications,
        ResumeCoverLetter,
        QuestionItem,
    },
    props: {
        value: { type: Object, default: initApplication },
    },
    data: () => ({
        shows: false,
    }),
    watch: {
        shows(shows) {
            if (shows) setTimeout(this.print, 500);
        },
    },
    methods: {
        print() {
            let title = document.title;

            document.title = `지원서-${this.value?.resume?.personalInformation?.name}-${this.value?.appliedAt?.toDate?.().replaceAll(/-/g, "")}`;

            let parentElm = document.getElementsByClassName("v-application--wrap")[0];
            console.log(parentElm);
            parentElm.style.overflowY = "auto";

            for (let node of parentElm.childNodes) {
                node.style.display = "none";
            }

            parentElm.nextElementSibling.style.display = "none";
            parentElm.nextElementSibling.nextElementSibling.style.display = "none";

            let targetElm = document.getElementById("print-target").cloneNode(true);
            parentElm.appendChild(targetElm);

            setTimeout(() => {
                window.print();
            }, 100);

            setTimeout(() => {
                parentElm.removeChild(targetElm);

                parentElm.nextElementSibling.style.display = null;
                parentElm.nextElementSibling.nextElementSibling.style.display = null;

                for (let node of parentElm.childNodes) {
                    node.style.display = null;
                }

                parentElm.style.overflowY = null;

                document.title = title;

                this.shows = false;
            }, 300);
        },
    },
};
</script>

<style></style>
